(ns scittle.tmdjs
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [tech.v3.dataset]))

;; Plugin: tmdjs
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::tmdjs
   {:namespaces
   {'tech.v3.dataset (sci/copy-ns tech.v3.dataset (sci/create-ns 'tech.v3.dataset nil))}}
   ))
